<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="localFilters.match"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
      <meta-button type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formatedList"
        :rows-per-page-items="[10, 25]"
        item-key="_id"
        :loading="loading"
        disable-initial-sort
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon color="error" @click="ifDelete(props.item._id)">
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.region }}</td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'ProvinceList',
  components: { DialogDelete, DialogUpdatedRecord },

  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function () {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('provinces')
      },
    },
    'localPagination.page': {
      handler: function () {
        this.debounceFetch('provinces')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function () {
        this.debounceFetch('provinces')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.provinces.loading,
      selected: (state) => state.provinces.selected,
      pagination: (state) => state.provinces.pagination,
      filters: (state) => state.provinces.filters,
    }),
    ...mapGetters({
      formatedList: 'provinces/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          value: '_id',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$tc('models.region'),
          value: 'region',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
          sortable: false,
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('provinces/setPagination', value)
      },
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('provinces/setFilters', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'provinces/fetchOne',
      setDelete: 'provinces/delete',
      reset: 'provinces/reset',
    }),
    setOne(id) {
      this.fetchOne(id).then(() => this.$emit('form'))
    },
    openUpdated(id) {
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
  },
}
</script>
